import TextField from "@mui/material/TextField";

export function Input(props: any) {
	const {
		name,
		type,
		label,
		value,
		error = null,
		onChange,
		fullWidth = true,
		disabled,
		placeholder,
		inputProps,
		className,
		size = "medium",
		required = false,
    minRows="1",
    multiline=false
	} = props;
	return (
    <TextField
      variant="outlined"
      required={required}
      label={label}
      placeholder={placeholder}
      autoComplete="none"
      name={name}
      type={type || "text"}
      value={value}
      fullWidth={fullWidth}
      onChange={onChange}
      disabled={disabled}
      inputProps={inputProps?inputProps:""}
    InputProps={inputProps?inputProps:""}
      className={className}
      size={size}
      minRows={minRows}
      multiline={multiline}

      {...(error && { error: true, helperText: error })}
    />
  );
}
